const addParameter = ( state, action ) => {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
						el.parameters = [...el.parameters, { name: '', required: false, type: 'any', default: '' }];
					}
					return el;
				}),
			]
		}
	};
};

const addParameterFilled = ( state, action ) => {
  return {
    ...state,
    settings: {
      ...state.settings,
      endpoints: [
        ...state.settings.endpoints.map((el, index) => {
          if ( index === action.payLoad.endpointId ) {
            el.parameters = [...el.parameters, { name: action.payLoad.name, required: false, type: 'any', default: '' }];
          }
          return el;
        }),
      ]
    }
  };
};

const removeParameter = ( state, action ) => {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
						el.parameters = el.parameters.filter((el, index) => {
							return index !== action.payLoad.paramId;
						});
					}
					return el;
				}),
			]
		}
	};
};

const changeParameter = ( state, action ) => {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
						el.parameters = el.parameters.map( (el, index) => {
							if ( index === action.payLoad.paramId ) {
								return {
									...el,
									[action.payLoad.field]: action.payLoad.value
								}
							}
							return el;
						});
					}
					return el;
				}),
			]
		}
	};
};

export { addParameter, addParameterFilled, removeParameter, changeParameter };
